module.exports = __webpack_public_path__ + "static/media/Coin_RZR Gold_White_dark-background.c62d2afb.png";